import {useEffect, useRef, useState} from 'react';
import {StyledPdfAgreement} from './autoBankCharge.styled';
import {createPdfFromHtml} from '../../common/shared/statelessMethods';
import BllinkUtils from '../../common/utils/utils';
import {useTranslation} from 'react-i18next';
import {fileToBase64} from '../../../utils/fileToBase64';

const BllinkTime = BllinkUtils.BllinkTime;

export function AutoChargePdf({address, apartmentNumber, formData, tenantDetails, signature, hidePdf, onSuccess}) {
    const {t} = useTranslation();
    const [pdfImage, setPdfImage] = useState(null);
    const container = useRef(null);

    useEffect(async () => {
        if (pdfImage == null) {
            // load dynamically to exclude from common bundle
            const module = await import('./pdf');
            setPdfImage(module.pdfImage);
        }
    });

    useEffect(async () => {
        if (container.current && pdfImage != null) {
            const file = await createPdfFromHtml(container.current, '', {save: false, ignoreLastPage: true});
            await upload(file);
            hidePdf();
        }
    }, [container, pdfImage]);

    const upload = async (file) => {
        const imageBase64 = await fileToBase64(file);
        const imageName = `${apartmentNumber},${address.full_address}${t('auto_charge.fileName')}.pdf`;
        onSuccess({ imageBase64, imageName });
    }

    return (
        <StyledPdfAgreement>
            <div className='wrapper' ref={container}>
                <div className='bg'>
                    <img src={pdfImage} alt="document" />
                </div>
                <p className='pdf-data address'>{address.full_address}</p>
                <p className='pdf-data phone'>{tenantDetails.phone}</p>
                <p className='pdf-data phone-in-table'>{tenantDetails.phone}</p>
                <p className='pdf-data email'>{tenantDetails.email}</p>
                <p className='pdf-data name'>{tenantDetails.name}</p>
                <p className='pdf-data check'>&#10003;</p>
                <p className='pdf-data owner-id'>{formData.ownerId}</p>
                <div className='pdf-data signature'>
                    <img src={signature} alt="signature" />
                </div>
                <p className='pdf-data bank-code'>{formData.bankCode.value}</p>
                <p className='pdf-data branch-code-right'>{formData.branchNumber}</p>
                <p className='pdf-data bank-name'>{formData.bankCode.label}</p>
                <p className='pdf-data account'>{formData.accountNumber}</p>
                <p className='pdf-data date'>{BllinkTime.parseDate(formData.date)}</p>
                <p className='pdf-data branch'>{formData.branchNumber}</p>
            </div>
        </StyledPdfAgreement>
    )
}
